"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _radixUi = require("radix-ui");
var _sheet = require("@design/ui/sheet");
var _materialSymbols = require("@design/icons/material-symbols");
var _alert = require("@design/ui/alert");
var _button = require("@design/ui/button");
var _utils = require("@design/lib/utils");
var _closeButton = require("@design/ui/close-button");
var _IssueActionBar = _interopRequireDefault(require("@common/components/review/IssueActionBar"));
var _IssueDescription = _interopRequireDefault(require("@common/components/issues/IssueDescription"));
var _IssueReasoning = _interopRequireWildcard(require("@common/components/issues/IssueReasoning"));
var _ImportanceBadge = _interopRequireDefault(require("@common/components/issues/ImportanceBadge"));
var _IssueStageProgressBar = require("@common/components/issues/IssueStageProgressBar");
var _RedlinePreview = _interopRequireDefault(require("@common/components/remedy/RedlinePreview"));
var _CommentPreview = _interopRequireDefault(require("@common/components/remedy/CommentPreview"));
var _RemedyActionPrimitives = require("@common/components/remedy/RemedyActionPrimitives");
var _liveReviewOoxml = require("@common/utils/liveReviewOoxml");
var _applyOutcome = require("@common/utils/applyOutcome");
var _appliedActions = require("@common/constants/appliedActions");
var _liveReviewActionState = require("@common/utils/liveReviewActionState");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t4 in e) "default" !== _t4 && {}.hasOwnProperty.call(e, _t4) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t4)) && (i.get || i.set) ? o(f, _t4, i) : f[_t4] = e[_t4]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var HEADER_ROW_CLASS = "flex items-center gap-2";
var EYEBROW_CLASS = "text-label-sm uppercase tracking-wide text-foreground-muted";
var SECTION_CLASS = "flex flex-col gap-1.5";
var SECTION_DETAIL_CLASS = "text-caption text-foreground-muted";
var EMPTY_NOTE_CLASS = "text-caption italic text-foreground-muted";
var SECTION_HEADER_ROW_CLASS = "flex flex-wrap items-center gap-2";
var SPACER_CLASS = "flex-auto";
var REASONING_SECTION_LABELS = {
  triggered: "Why this triggered",
  "not-triggered": "Why this did not trigger",
  "not-run": "Why this was not run"
};
function LiveReviewIssueDrawer(_ref) {
  var _visibleIssues$curren, _issue$remedies, _issue$comments, _primaryRemedy$target;
  var initialIssue = _ref.issue,
    initialFilteredIndex = _ref.filteredIndex,
    visibleIssues = _ref.visibleIssues,
    reviewIssues = _ref.reviewIssues,
    playbookName = _ref.playbookName,
    conversationId = _ref.conversationId,
    messageId = _ref.messageId,
    onClose = _ref.onClose,
    interactions = _ref.interactions;
  var _useState = (0, _react.useState)(initialFilteredIndex),
    _useState2 = _slicedToArray(_useState, 2),
    currentIndex = _useState2[0],
    setCurrentIndex = _useState2[1];
  (0, _react.useEffect)(function () {
    setCurrentIndex(initialFilteredIndex);
  }, [initialFilteredIndex, initialIssue.ruleUuid]);
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    busyKey = _useState4[0],
    setBusyKey = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    applyError = _useState6[0],
    setApplyError = _useState6[1];
  var issue = (_visibleIssues$curren = visibleIssues[currentIndex]) !== null && _visibleIssues$curren !== void 0 ? _visibleIssues$curren : initialIssue;
  var issueKey = (0, _liveReviewOoxml.liveReviewIssueKey)(issue);
  var primaryRemedy = (_issue$remedies = issue.remedies) === null || _issue$remedies === void 0 ? void 0 : _issue$remedies[0];
  var primaryComment = (_issue$comments = issue.comments) === null || _issue$comments === void 0 ? void 0 : _issue$comments[0];
  var primaryRemedyId = primaryRemedy === null || primaryRemedy === void 0 ? void 0 : primaryRemedy.id;
  var primaryCommentId = primaryComment === null || primaryComment === void 0 ? void 0 : primaryComment.id;
  var hasPrimaryRemedy = !!primaryRemedy;
  var hasPrimaryComment = !!primaryComment;
  var remedyNavBookmarks = (_primaryRemedy$target = primaryRemedy === null || primaryRemedy === void 0 ? void 0 : primaryRemedy.targetBookmarks) !== null && _primaryRemedy$target !== void 0 ? _primaryRemedy$target : issue.detectionBookmarks;
  var commentNavBookmarks = primaryComment !== null && primaryComment !== void 0 && primaryComment.bookmark ? [primaryComment.bookmark] : issue.detectionBookmarks;
  var staticPreviewOoxml = primaryRemedy && !interactions ? (0, _liveReviewOoxml.remedyPreviewOoxml)(primaryRemedy) : "";
  var remedyActionId = primaryRemedyId ? (0, _liveReviewOoxml.buildActionId)(messageId, issueKey, "remedy", primaryRemedyId) : null;
  var commentActionId = primaryCommentId ? (0, _liveReviewOoxml.buildActionId)(messageId, issueKey, "comment", primaryCommentId) : null;
  var concedeId = (0, _liveReviewOoxml.buildConcedeId)(messageId, issueKey);
  var remedyApplied = !!interactions && !!remedyActionId && interactions.isActionApplied(conversationId, remedyActionId);
  var commentApplied = !!interactions && !!commentActionId && interactions.isActionApplied(conversationId, commentActionId);
  var remedyDismissed = !!interactions && !!remedyActionId && interactions.isActionDismissed(conversationId, remedyActionId);
  var commentDismissed = !!interactions && !!commentActionId && interactions.isActionDismissed(conversationId, commentActionId);
  var isConceded = !!interactions && interactions.isActionDismissed(conversationId, concedeId);
  var remedySupersededBy = !!interactions && !!remedyActionId ? interactions.getActionSupersession(conversationId, remedyActionId) : undefined;
  var remedySuperseded = !!remedySupersededBy;
  var remedyPartlyAppliedReason = remedyActionId && interactions !== null && interactions !== void 0 && interactions.partlyAppliedReasonOf ? interactions.partlyAppliedReasonOf(conversationId, remedyActionId) : null;
  var commentHeldBackReason = primaryComment && interactions !== null && interactions !== void 0 && interactions.commentHeldBackReason ? interactions.commentHeldBackReason(issue, primaryComment) : null;
  var commentState = interactions && primaryComment ? (0, _liveReviewActionState.issueCommentStateOf)(issue, primaryComment, commentActionId, remedyActionId, conversationId, interactions) : null;
  var isResponded = remedyApplied || remedyPartlyAppliedReason !== null || commentApplied && !remedySuperseded;
  function onApplyRemedy() {
    return _onApplyRemedy.apply(this, arguments);
  }
  function _onApplyRemedy() {
    _onApplyRemedy = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var remedyLanded, markActionAsPartlyApplied;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (!(!interactions || !primaryRemedy || !remedyActionId || remedyApplied || busyKey)) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2, false);
          case 1:
            setBusyKey(remedyActionId);
            setApplyError(null);
            remedyLanded = false;
            markActionAsPartlyApplied = interactions.markActionAsPartlyApplied;
            _context2.p = 2;
            _context2.n = 3;
            return (0, _applyOutcome.runRecordedApply)(function () {
              return interactions.applyRemedy(issue, primaryRemedy);
            }, {
              markApplied: function markApplied() {
                remedyLanded = true;
                interactions.markActionAsApplied(conversationId, remedyActionId);
              },
              markFailed: function markFailed(reason) {
                return interactions.markActionAsFailed(conversationId, remedyActionId, reason);
              },
              markPartlyApplied: markActionAsPartlyApplied === undefined ? undefined : function (partlyApplied) {
                remedyLanded = true;
                markActionAsPartlyApplied(conversationId, remedyActionId, (0, _appliedActions.applyFailureReason)(partlyApplied), partlyApplied.message);
              },
              onError: function onError(error) {
                setApplyError(error.message);
                interactions.onError(error, {
                  component: "LiveReviewIssueDrawer",
                  action: "apply_remedy",
                  conversationId: conversationId,
                  messageId: messageId,
                  issueId: issueKey
                });
              }
            });
          case 3:
            _context2.p = 3;
            setBusyKey(null);
            return _context2.f(3);
          case 4:
            return _context2.a(2, remedyLanded);
        }
      }, _callee2, null, [[2,, 3, 4]]);
    }));
    return _onApplyRemedy.apply(this, arguments);
  }
  function onApplyCommentRow() {
    return _onApplyCommentRow.apply(this, arguments);
  }
  function _onApplyCommentRow() {
    _onApplyCommentRow = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            if (!(!interactions || !primaryComment || !commentActionId || commentApplied || busyKey)) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            setBusyKey(commentActionId);
            setApplyError(null);
            _context3.p = 2;
            _context3.n = 3;
            return (0, _applyOutcome.runRecordedApply)(function () {
              return interactions.applyComment(issue, primaryComment);
            }, {
              markApplied: function markApplied() {
                return interactions.markActionAsApplied(conversationId, commentActionId);
              },
              markFailed: function markFailed(reason) {
                return interactions.markActionAsFailed(conversationId, commentActionId, reason);
              },
              onError: function onError(error) {
                setApplyError(error.message);
                interactions.onError(error, {
                  component: "LiveReviewIssueDrawer",
                  action: "apply_comment",
                  conversationId: conversationId,
                  messageId: messageId,
                  issueId: issueKey
                });
              }
            });
          case 3:
            _context3.p = 3;
            setBusyKey(null);
            return _context3.f(3);
          case 4:
            return _context3.a(2);
        }
      }, _callee3, null, [[2,, 3, 4]]);
    }));
    return _onApplyCommentRow.apply(this, arguments);
  }
  function onApplyBoth() {
    if (!interactions) return;
    void _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var remedyAppliedNow, commentWaitsForItsNewParagraph, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!(hasPrimaryRemedy && !remedyApplied && !remedyDismissed && !remedySuperseded)) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return onApplyRemedy();
          case 1:
            _t = _context.v;
            _context.n = 3;
            break;
          case 2:
            _t = false;
          case 3:
            remedyAppliedNow = _t;
            commentWaitsForItsNewParagraph = !!primaryComment && (0, _liveReviewActionState.commentSitsOnTheParagraphItsRemedyAdds)(primaryComment, issue) && !!remedyActionId && !remedyAppliedNow && !(0, _liveReviewActionState.remedyLandedItsParagraphs)(remedyActionId, conversationId, interactions);
            if (!(hasPrimaryComment && !commentApplied && !commentDismissed && commentHeldBackReason === null && !commentWaitsForItsNewParagraph)) {
              _context.n = 4;
              break;
            }
            _context.n = 4;
            return onApplyCommentRow();
          case 4:
            return _context.a(2);
        }
      }, _callee);
    }))();
  }
  function onUnmark() {
    if (!interactions) return;
    if (remedyActionId && remedyApplied) interactions.markActionAsUnapplied(conversationId, remedyActionId);
    if (commentActionId && commentApplied) interactions.markActionAsUnapplied(conversationId, commentActionId);
  }
  function isDismissalSaving(actionId) {
    return !!interactions && !!actionId && interactions.isActionDismissalSaving(conversationId, actionId);
  }
  function isActionBusy(actionId) {
    return !!actionId && (busyKey === actionId || isDismissalSaving(actionId));
  }
  function saveDismissal(_x, _x2) {
    return _saveDismissal.apply(this, arguments);
  }
  function _saveDismissal() {
    _saveDismissal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(actionId, save) {
      var _t2;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            if (!(!interactions || isActionBusy(actionId))) {
              _context4.n = 1;
              break;
            }
            return _context4.a(2);
          case 1:
            _context4.p = 1;
            _context4.n = 2;
            return save();
          case 2:
            _context4.n = 4;
            break;
          case 3:
            _context4.p = 3;
            _t2 = _context4.v;
            interactions.notifySaveFailure();
          case 4:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return _saveDismissal.apply(this, arguments);
  }
  function onToggleConcede() {
    if (!interactions) return;
    void saveDismissal(concedeId, function () {
      return isConceded ? interactions.markActionAsUndismissed(conversationId, concedeId) : interactions.markActionAsDismissed(conversationId, concedeId);
    });
  }
  function goToBookmarks(_x3) {
    return _goToBookmarks.apply(this, arguments);
  }
  function _goToBookmarks() {
    _goToBookmarks = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(bookmarks) {
      var _t3;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            if (!(!interactions || !(bookmarks !== null && bookmarks !== void 0 && bookmarks.length))) {
              _context5.n = 1;
              break;
            }
            return _context5.a(2);
          case 1:
            _context5.p = 1;
            _context5.n = 2;
            return interactions.goToBookmarks(bookmarks);
          case 2:
            _context5.n = 4;
            break;
          case 3:
            _context5.p = 3;
            _t3 = _context5.v;
            interactions.onError(_t3 instanceof Error ? _t3 : new Error(String(_t3)), {
              component: "LiveReviewIssueDrawer",
              action: "go_to_bookmarks",
              conversationId: conversationId,
              messageId: messageId,
              issueId: issueKey
            });
          case 4:
            return _context5.a(2);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return _goToBookmarks.apply(this, arguments);
  }
  function onDismissRemedy() {
    if (interactions && remedyActionId) void saveDismissal(remedyActionId, function () {
      return interactions.markActionAsDismissed(conversationId, remedyActionId);
    });
  }
  function onUndismissRemedy() {
    if (interactions && remedyActionId) void saveDismissal(remedyActionId, function () {
      return interactions.markActionAsUndismissed(conversationId, remedyActionId);
    });
  }
  function onDismissComment() {
    if (interactions && commentActionId) void saveDismissal(commentActionId, function () {
      return interactions.markActionAsDismissed(conversationId, commentActionId);
    });
  }
  function onUndismissComment() {
    if (interactions && commentActionId) void saveDismissal(commentActionId, function () {
      return interactions.markActionAsUndismissed(conversationId, commentActionId);
    });
  }
  var hasPrev = currentIndex > 0;
  var hasNext = currentIndex < visibleIssues.length - 1;
  var isApplyDisabled = (!primaryRemedy || remedyApplied || remedyDismissed || remedySuperseded) && (!primaryComment || commentApplied || commentDismissed || (commentState === null || commentState === void 0 ? void 0 : commentState.kind) === "heldBack");
  function renderRemedyControls() {
    if (!interactions) return null;
    var isRemedyBusy = isActionBusy(remedyActionId);
    var isRemedyApplying = busyKey === remedyActionId;
    var isRemedyDismissalSaving = isDismissalSaving(remedyActionId);
    if (remedyDismissed) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyDismissedIndicator, {
      onClick: onUndismissRemedy,
      isSaving: isRemedyDismissalSaving,
      disabled: isRemedyApplying
    });
    if (remedyPartlyAppliedReason !== null) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyPartlyAppliedIndicator, {
      reason: remedyPartlyAppliedReason
    });
    if (remedyApplied) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyAppliedIndicator, {});
    if (remedySupersededBy) {
      var superseder = (0, _liveReviewActionState.supersedingIssueViewOf)(remedySupersededBy, reviewIssues, visibleIssues, setCurrentIndex);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedySupersededIndicator, {
        supersededBy: superseder.label,
        onShowSuperseder: superseder.onShow
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyApplyButton, {
        label: "Apply redline",
        isLoading: isRemedyApplying,
        disabled: isRemedyBusy,
        onClick: onApplyRemedy,
        "data-sentry-element": "RemedyApplyButton",
        "data-sentry-source-file": "LiveReviewIssueDrawer.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyGoToIssueButton, {
        onClick: function onClick() {
          return void goToBookmarks(remedyNavBookmarks);
        },
        "data-sentry-element": "RemedyGoToIssueButton",
        "data-sentry-source-file": "LiveReviewIssueDrawer.tsx",
        children: "Go to issue"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyDismissButton, {
        onClick: onDismissRemedy,
        isSaving: isRemedyDismissalSaving,
        disabled: isRemedyApplying,
        "data-sentry-element": "RemedyDismissButton",
        "data-sentry-source-file": "LiveReviewIssueDrawer.tsx"
      })]
    });
  }
  function renderCommentControls() {
    if (!interactions || commentState === null) return null;
    var isCommentBusy = isActionBusy(commentActionId);
    var isCommentApplying = busyKey === commentActionId;
    var isCommentDismissalSaving = isDismissalSaving(commentActionId);
    var dismissButton = /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyDismissButton, {
      onClick: onDismissComment,
      isSaving: isCommentDismissalSaving,
      disabled: isCommentApplying
    });
    var commentControlsToAdd = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyApplyButton, {
        label: "Add comment",
        isLoading: isCommentApplying,
        disabled: isCommentBusy,
        onClick: onApplyCommentRow
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyGoToIssueButton, {
        onClick: function onClick() {
          return void goToBookmarks(commentNavBookmarks);
        },
        children: "Go to issue"
      }), dismissButton]
    });
    switch (commentState.kind) {
      case "dismissed":
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyDismissedIndicator, {
          onClick: onUndismissComment,
          isSaving: isCommentDismissalSaving,
          disabled: isCommentApplying
        });
      case "applied":
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyAppliedIndicator, {});
      case "heldBack":
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyHeldBackIndicator, {
            heldBackReason: commentState.heldBackReason
          }), dismissButton]
        });
      case "failed":
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [commentControlsToAdd, /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyFailedIndicator, {
            reason: commentState.failureReason
          })]
        });
      case "pending":
        return commentControlsToAdd;
    }
  }
  var remedySection = primaryRemedy ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
    className: SECTION_CLASS,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: SECTION_HEADER_ROW_CLASS,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: EYEBROW_CLASS,
        children: "Proposed redline"
      }), primaryRemedy.diffCount ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: SECTION_DETAIL_CLASS,
        children: ["+", primaryRemedy.diffCount.added, " / -", primaryRemedy.diffCount.removed, " changes"]
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: SPACER_CLASS
      }), renderRemedyControls()]
    }), interactions ? interactions.renderRemedyPreview(issue, primaryRemedy, {
      dismissed: remedyDismissed,
      applied: remedyApplied
    }) : staticPreviewOoxml ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedlinePreview.default, {
      ooxml: staticPreviewOoxml
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: EMPTY_NOTE_CLASS,
      children: "The redline will be available once the review is applied."
    })]
  }) : null;
  var commentSection = primaryComment ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
    className: SECTION_CLASS,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: SECTION_HEADER_ROW_CLASS,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: EYEBROW_CLASS,
        children: "Proposed comment"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: SPACER_CLASS
      }), renderCommentControls()]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommentPreview.default, {
      text: primaryComment.text
    })]
  }) : null;
  var outcome = (0, _IssueReasoning.reasoningOutcomeOf)(issue.match, issue.stage);
  var reasoningSection = issue.match || issue.reasoning ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
    className: SECTION_CLASS,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: EYEBROW_CLASS,
      children: REASONING_SECTION_LABELS[outcome]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_IssueReasoning.default, {
      text: issue.reasoning || "",
      outcome: outcome
    })]
  }) : null;
  function renderOutcomeNote() {
    if (issue.stage === "error") {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
        className: SECTION_CLASS,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: EMPTY_NOTE_CLASS,
          children: "This rule could not be reviewed."
        }), issue.error ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: SECTION_DETAIL_CLASS,
          children: issue.error
        }) : null]
      });
    }
    if (issue.stage === "skipped") return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: EMPTY_NOTE_CLASS,
      children: "This rule was not run."
    });
    if (!issue.match) return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: EMPTY_NOTE_CLASS,
      children: "This rule did not trigger on the document."
    });
    return null;
  }
  var footer = interactions ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IssueActionBar.default, {
    onPrev: function onPrev() {
      return hasPrev && setCurrentIndex(currentIndex - 1);
    },
    onNext: function onNext() {
      return hasNext && setCurrentIndex(currentIndex + 1);
    },
    hasPrev: hasPrev,
    hasNext: hasNext,
    onApplyAll: isResponded ? onUnmark : onApplyBoth,
    onConcede: onToggleConcede,
    isResponded: isResponded,
    isConceded: isConceded,
    isConcedePending: isDismissalSaving(concedeId),
    isApplyDisabled: !isResponded && isApplyDisabled,
    applyLabel: primaryRemedy && primaryComment ? "Apply remedy + comment" : primaryRemedy ? "Apply redline" : primaryComment ? "Add comment" : "Apply"
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex h-10 flex-none items-center justify-between bg-background-subtle px-2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      type: "button",
      variant: "ghost",
      size: "icon-xs",
      onClick: function onClick() {
        return hasPrev && setCurrentIndex(currentIndex - 1);
      },
      disabled: !hasPrev,
      "aria-label": "Previous issue",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronLeftIcon, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      type: "button",
      variant: "ghost",
      size: "icon-xs",
      onClick: function onClick() {
        return hasNext && setCurrentIndex(currentIndex + 1);
      },
      disabled: !hasNext,
      "aria-label": "Next issue",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {})
    })]
  });
  var header = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-2 border-b border-border-default px-3 pt-3 pb-2.5",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: HEADER_ROW_CLASS,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
        type: "button",
        variant: "ghost",
        size: "icon-sm",
        onClick: onClose,
        "aria-label": "Back to chat",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowBackIcon, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: EYEBROW_CLASS,
        children: playbookName || "Playbook Review"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: HEADER_ROW_CLASS,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ImportanceBadge.default, {
        importance: issue.importance
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Title, {
        asChild: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          className: "m-0 min-w-0 flex-auto text-h4 wrap-anywhere",
          children: issue.name || "Issue"
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _utils.cn)("h-0.75 rounded-xs", (0, _IssueStageProgressBar.riskBarClass)(issue.stage, issue.importance, issue.match, isResponded, isConceded))
    })]
  });
  var body = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-auto flex-col gap-4 overflow-y-auto p-3",
    children: [issue.description ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
      className: SECTION_CLASS,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: EYEBROW_CLASS,
        children: "Rule"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_IssueDescription.default, {
        text: issue.description
      })]
    }) : null, reasoningSection, remedySection, commentSection, !primaryRemedy && !primaryComment && issue.match ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: EMPTY_NOTE_CLASS,
      children: "This issue triggered but no remedy or comment was proposed."
    }) : null, renderOutcomeNote(), applyError ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_alert.Alert, {
      variant: "destructive",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_alert.AlertDescription, {
        children: ["Could not apply: ", applyError]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_alert.AlertAction, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_closeButton.CloseButton, {
          onClick: function onClick() {
            return setApplyError(null);
          },
          "aria-label": "Dismiss error",
          size: "icon-xs"
        })
      })]
    }) : null]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_sheet.Sheet, {
    open: true,
    onOpenChange: function onOpenChange(open) {
      return open || onClose();
    },
    "data-sentry-element": "Sheet",
    "data-sentry-component": "LiveReviewIssueDrawer",
    "data-sentry-source-file": "LiveReviewIssueDrawer.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_sheet.SheetContent, {
      side: "right",
      showCloseButton: false,
      "aria-describedby": undefined,
      className: "gap-0 data-[side=right]:border-l-0 bg-white text-[length:inherit] text-inherit shadow-none data-[side=right]:w-full data-[side=right]:sm:max-w-none",
      "data-sentry-element": "SheetContent",
      "data-sentry-source-file": "LiveReviewIssueDrawer.tsx",
      children: [header, body, footer]
    })
  });
}
var _default = exports.default = LiveReviewIssueDrawer;